import React, { useEffect, useState, useMemo } from 'react';
import {
  withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Card,
  Row,
  Col,
  Table,
  Modal,
  Input,
  Button,
  Icon,
  message,
  Spin,
} from 'antd';
import {
  LYNX_CONNECT,
  ROLES,
} from 'appconstants';
import RBAC from 'components/rbac';
import {
  SpButton,
} from 'components/DesignKit';
import debounce from 'lodash.debounce';
import { CSVLink } from 'react-csv';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { lynxConnectActions, lynxTenantDetailActions } from 'store/actions';
import currencyformatter from 'utils/currencyformatter';
import GreenIncreaseIndicator from 'assets/imgs/green-increase-indicator.svg';
import RedDecreaseIndicator from 'assets/imgs/red-decrease-indicator.svg';
import exportIcon from 'imgs/export.svg';
import EditableCostInput from '../EditCost/EditableCostInput';
import InvoiceDetail from '../InvoiceDetail';
import ViewInvoice from '../ViewInvoice';

type Props = {
  // loading: boolean,
  test: boolean,
  // validator: Boolean,
  location: {
    pathname: string,
    search: string,
  },
  history: {
    push: Function,
  },
  selectedAccount: Object,
  // submitting: Boolean,
  lynxTenantDetails: Array,
  lynxConnectExistItems: Array,
  lynxConnectExistItemsTotalElements: Number,
  lynxConnectExistItemHistory: Array,
  lynxConnectExistEditRowSyncStatus: String,
  fetchExist: Function,
  fetchExistHistory: Function,
  existUpdateAll: Function,
  existEditRowSync: Function,
  // existRowSync: Function,
  existUpdatePos: Function,
  existEditRowSyncStatus: Function,
  lynxConnectExistSingleLineItem: Object,
  existSetSingleLineItemValue: Function,
  existSetTableData: Function,
  resetExistLineItems: Function,
  lynxConnectExistUpdatePosStatus: String,
  setPosStatus: Function,
  fetchLynxTenantDetails: Function,
  lynxConnectInvoiceDetail: {
    vendorName: String | null,
    invoiceNumber: String | null,
    totalAmount: Number | null,
    billedTo: String | null,
    invoiceDate: String | null,
    subTotalAmount: Number | null,
    fileName: String | null,
  },
  lynxConnectInvoicePdf: Object,
  // setInvoicePdf: Function,
  lynxConnectLoading: Boolean,
  fetchInvoicePdf: Function,
  fetchInvoiceDetail: Function,
  lynxConnectSubLoading: {
    invoiceDetail: Boolean,
    pdfData: Boolean,
  },
  userRole: Object,
  setAuditEvent: Function,
  requestApproval: Function,
  setExistLineItemTotalElements: Function,
};

const SmallHeaderTable = styled.div`
  .ant-table-column-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    padding: 0px;
  }
`;

const LynxConnectInvoiceLineItemsExist = (props: Props) => {
  const {
    // loading,
    // validator,
    selectedAccount,
    // submitting,
    test,
    history,
    location,
    lynxTenantDetails,
    lynxConnectExistItems,
    lynxConnectExistItemsTotalElements,
    lynxConnectExistItemHistory,
    lynxConnectExistEditRowSyncStatus,
    fetchExist,
    fetchExistHistory,
    existUpdateAll,
    existEditRowSync,
    // existRowSync,
    existUpdatePos,
    existEditRowSyncStatus,
    lynxConnectExistSingleLineItem,
    existSetSingleLineItemValue,
    existSetTableData,
    resetExistLineItems,
    lynxConnectExistUpdatePosStatus,
    setPosStatus,
    fetchLynxTenantDetails,
    lynxConnectInvoiceDetail,
    lynxConnectInvoicePdf,
    // setInvoicePdf,
    lynxConnectLoading,
    fetchInvoicePdf,
    fetchInvoiceDetail,
    lynxConnectSubLoading,
    userRole,
    setAuditEvent,
    requestApproval,
    setExistLineItemTotalElements,
  } = props;

  // reset the state on page load
  // to remove the old state information
  useEffect(() => {
    resetExistLineItems({});
    // get the lynx tenant details
    fetchLynxTenantDetails();
    // fetch the invoice and pdf details
    if (/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      const invoiceGid = location.pathname.split('/').slice(-1)[0];
      fetchInvoiceDetail({
        gid: invoiceGid,
      });
      fetchInvoicePdf({
        gid: invoiceGid,
      });
    }
  }, []);

  const [isEditing, setIsEditing] = useState(false);
  const [tableFieldValue, setTableFieldValue] = useState({});
  const [showLineItemHistory, setShowLineItemHistory] = useState(false);
  const [csvFileName, setCsvFileName] = useState('Existing_Line_Items.csv');
  const [showPdfCard, setShowPdfCard] = useState(false);

  const debouncedFetchInvoiceLineItemsHistory = useMemo(() => (
    debounce(fetchExistHistory, 500, { leading: true })
  ), [fetchExistHistory]);

  const debouncedUpdateAll = useMemo(() => (
    debounce(existUpdateAll, 2000, { leading: true })
  ), [existUpdateAll]);

  const debouncedEditModeRowSync = useMemo(() => (
    debounce(existEditRowSync, 1000, { leading: true })
  ), [existEditRowSync]);

  // const debouncedRowSync = useMemo(() => (
  //   debounce(existRowSync, 2000, { leading: true })
  // ), [existRowSync]);

  const fileExportHeaders = useMemo(() => ([
    { label: 'ITEM NAME', key: 'itemName' },
    { label: 'BARCODE', key: 'barcode' },
    { label: 'SKU', key: 'sku' },
    { label: 'VENDOR ITEM CODE', key: 'vendorItemCode' },
    { label: 'QUANTITY', key: 'quantity' },
    { label: 'UNIT', key: 'unit' },
    { label: 'CASE COST', key: 'caseCost' },
    { label: 'CASE QUANTITY', key: 'caseQuantity' },
    { label: 'ITEM QUANTITY PER CASE', key: 'caseItemQuantity' },
    { label: 'TOTAL ITEM QUANTITY', key: 'totalCaseItemQuantity' },
    { label: 'ITEM COST', key: 'unitCost' },
    { label: 'NEW SELLING PRICE', key: 'newSellingPrice' },
    { label: 'OLD SELLING PRICE', key: 'oldSellingPrice' },
    { label: 'OLD MARGIN', key: 'oldMargin' },
    { label: 'NEW MARGIN', key: 'newMargin' },
    { label: 'TOTAL COST', key: 'totalCost' },
    { label: 'DESCRIPTION', key: 'description' },
    { label: 'HAND WRITTEN', key: 'handWritten' },
  ]), []);

  const fileExportData = useMemo(() => {
    const presetCurrencyFromatter = (value) => currencyformatter(Number(value) / 100, selectedAccount?.currency?.name);
    return lynxConnectExistItems.map((item) => ({
      itemName: item.itemName,
      barcode: item.barcode,
      sku: item.sku,
      vendorItemCode: item.vendorItemCode,
      quantity: item.quantity,
      unit: item.unit,
      caseCost: presetCurrencyFromatter(item.caseCost),
      caseQuantity: item.caseQuantity,
      caseItemQuantity: item.caseItemQuantity,
      totalCaseItemQuantity: item.totalCaseItemQuantity,
      unitCost: presetCurrencyFromatter(item.unitCost),
      newSellingPrice: presetCurrencyFromatter(item.newSellingPrice),
      oldSellingPrice: presetCurrencyFromatter(item.oldSellingPrice),
      oldMargin: `${item.oldMargin}%`,
      newMargin: `${item.newMargin}%`,
      totalCost: presetCurrencyFromatter(item.totalCost),
      description: item.description,
      handWritten: item.handWritten,
    }));
  }, [lynxConnectExistItems]);

  useEffect(() => {
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      return;
    }
    setCsvFileName(`Existing_Line_Items_${location.pathname.split('/').slice(-1)[0]}.csv`);
  }, [lynxConnectExistItems]);

  const handleCsvFileDownload = (e) => {
    if (fileExportData.length === 0) {
      message.error('No Data to Export!');
      e.preventDefault();
    } else {
      message.success('Starting Download...');
      if (/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
        setAuditEvent({
          gid: location.pathname.split('/').slice(-1)[0],
          payload: {
            eventHeader: 'Item Exported',
            eventOrigin: 'Review Existing Items',
          },
        });
      }
    }
  };

  const debouncedUpdatePos = useMemo(() => (
    debounce(existUpdatePos, 2000, { leading: true })
  ), [existUpdatePos]);

  const getData = (query) => {
    fetchExist({
      gid: query,
    });
  };

  useEffect(() => {
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      message.error('URL is Malformed.');
      return;
    }
    getData(location.pathname.split('/').slice(-1)[0]);
  }, [location, test, selectedAccount]);

  const handleTableFieldEdit = (lineItemGid, columnName, value) => {
    let processedValue = value;
    if (LYNX_CONNECT.INTEGER_FIELDS.includes(columnName)) {
      processedValue = !Number.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : '';
    }
    setTableFieldValue(state => {
      const newState = { ...state };
      newState[lineItemGid] = {
        ...state[lineItemGid],
        [columnName]: processedValue,
      };
      return newState;
    });
  };

  const commitChange = (lineItemGid, columnName, value) => {
    let parsedValue = '';
    if (!Number.isNaN(parseInt(value, 10))) {
      parsedValue = parseInt(value, 10);
    } else {
      parsedValue = 0;
    }
    setTableFieldValue(state => {
      const newState = { ...state };
      newState[lineItemGid] = {
        ...state[lineItemGid],
        [columnName]: parsedValue,
      };
      return newState;
    });
  };

  const handleEditModeRowSync = (lineItemGid) => {
    // call the api and on success reponse
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      return;
    }
    const item = tableFieldValue[lineItemGid];
    const payload = {
      name: item.itemName.trim(),
      barcode: item.barcode.trim(),
      sku: item.sku.trim(),
      itemCode: item.vendorItemCode.trim(),
      quantity: item.quantity,
      unit: item.unit.trim(),
      caseCost: item.caseCost,
      caseQuantity: item.caseQuantity,
      itemQuantityPerCase: item.caseItemQuantity,
      // totalItemQuantity: item.totalCaseItemQuantity, // calculated by the backend
      // price: item.unitCost, // calcualted by the backend
      newSellingPrice: item.newSellingPrice,
      // oldSellingPrice calculated by backend
      // oldMargin caculated by backend
      // newMargin calculated by backend
      // totalCost caculated by backend
      description: item.description.trim(),
      handWritten: item.handWritten.trim(),
    };
    debouncedEditModeRowSync({
      invoiceGid: location.pathname.split('/').slice(-1)[0],
      lineItemGid,
      payload,
    });
    // fetch action to get all validation line items,
    // but remain in edit mode?
  };

  // to update the entire content on successfull edit row sync
  // it bunches up multiple edit row sync and updates the content
  // all at once when needed
  // useEffect(() => {
  //   if (!isEditing
  //     && lynxConnectExistEditRowSyncStatus === 'Success'
  //     && /^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)
  //   ) {
  //     getData(location.pathname.split('/').slice(-1)[0]);
  //     existEditRowSyncStatus('');
  //   }
  // }, [isEditing, lynxConnectExistEditRowSyncStatus]);

  // update the edit mode table values as
  // soon as sync is pressed.
  useEffect(() => {
    if (lynxConnectExistSingleLineItem.length === 0) {
      return;
    }
    let newTableValues = {};
    lynxConnectExistSingleLineItem.forEach(item => {
      newTableValues = {
        ...tableFieldValue,
        [item.gid]: {
          ...item,
        },
      };
    });
    setTableFieldValue(newTableValues);
    existSetSingleLineItemValue([]);
  }, [lynxConnectExistSingleLineItem]);

  // remove the synced row from the table if the
  // status changes to no_match
  useEffect(() => {
    if (lynxConnectExistEditRowSyncStatus
      && lynxConnectExistEditRowSyncStatus.status === 'Success'
      && lynxConnectExistEditRowSyncStatus.syncStatus === 'NO_MATCH'
    ) {
      // remove the row from editable table state
      const tableValues = {
        ...tableFieldValue,
      };
      delete tableValues[lynxConnectExistEditRowSyncStatus.lineItemId];
      setTableFieldValue(tableValues);
      // reset the status
      existEditRowSyncStatus({
        status: '',
        lineItemId: null,
        syncStatus: null,
      });
      // change the table data
      existSetTableData(lynxConnectExistItems.filter(record => (
        record.gid !== lynxConnectExistEditRowSyncStatus.lineItemId
      )));
      // set the total number of elements
      setExistLineItemTotalElements(lynxConnectExistItemsTotalElements - 1);
    }
  }, [lynxConnectExistEditRowSyncStatus]);

  // change mode to non-editable; if the table
  // has no data
  useEffect(() => {
    if (Array.isArray(lynxConnectExistItems)
    && lynxConnectExistItems.length === 0
    ) {
      setIsEditing(false);
    }
  }, [isEditing, lynxConnectExistItems]);

  // const handleRowSync = (lineItemGid) => {
  //   // call the api to change them to existing item
  //   debouncedRowSync({
  //     gid: lineItemGid,
  //   });
  //   // on success response remove item from table data value
  //   // this is be done through a fetch all validate line items acton
  // };

  const handleRequestButton = () => {
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      message.error('URL is Malformed.');
      return;
    }
    requestApproval({
      gid: location.pathname.split('/').slice(-1)[0],
      existLineItemPage: true,
    });
  };

  const handlePosUpdate = () => {
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      message.error('URL is Malformed.');
      return;
    }
    // call the update POS api
    debouncedUpdatePos({
      invoiceGid: location.pathname.split('/').slice(-1)[0],
      existLineItemPage: true,
    });
  };

  // listen for message from POS update
  // to change page to invoice
  useEffect(() => {
    if (lynxConnectExistUpdatePosStatus === 'Success') {
      history.push('/lynxconnect/invoices');
    }
    setPosStatus('');
  }, [lynxConnectExistUpdatePosStatus]);

  const handleEdit = () => {
    // create the input state object with
    // table data values
    if (!Array.isArray(lynxConnectExistItems)
      || lynxConnectExistItems.length === 0
    ) {
      message.error('No Data to Edit.');
      return;
    }
    const tableValue = {};
    lynxConnectExistItems.forEach((item) => {
      tableValue[item.gid] = {
        gid: String(item.gid ?? ''),
        itemName: String(item.itemName ?? ''),
        barcode: String(item.barcode ?? ''),
        sku: String(item.sku ?? ''),
        vendorItemCode: String(item.vendorItemCode ?? ''),
        quantity: Number(item.quantity ?? 0),
        unit: String(item.unit ?? ''),
        caseCost: Number(item.caseCost ?? 0),
        caseQuantity: Number(item.caseQuantity ?? 0),
        caseItemQuantity: Number(item.caseItemQuantity ?? 0),
        totalCaseItemQuantity: Number(item.totalCaseItemQuantity ?? 0),
        unitCost: Number(item.unitCost ?? 0),
        newSellingPrice: Number(item.newSellingPrice ?? 0),
        oldSellingPrice: Number(item.oldSellingPrice ?? 0),
        oldMargin: Number(item.oldMargin ?? 0),
        newMargin: Number(item.newMargin ?? 0),
        totalCost: Number(item.totalCost ?? 0),
        description: String(item.description ?? ''),
        handWritten: String(item.handWritten ?? ''),
        // previousCaseCost: Number(item.previousCaseCost ?? 0),
      };
    });
    setTableFieldValue(tableValue);
    // set editing as true
    setIsEditing(true);
  };

  const handleSave = () => {
    // call api and pass the tableFieldValue state as input
    const payload = {
      lineItems: Object.values(tableFieldValue).map((item) => ({
        lineItemId: item.gid,
        name: item.itemName.trim(),
        barcode: item.barcode.trim(),
        sku: item.sku.trim(),
        itemCode: item.vendorItemCode.trim(),
        quantity: item.quantity,
        unit: item.unit.trim(),
        caseCost: item.caseCost,
        caseQuantity: item.caseQuantity,
        itemQuantityPerCase: item.caseItemQuantity,
        // totalItemQuantity: item.totalCaseItemQuantity, // calculated by backend
        // price: item.unitCost, // calculated by backend
        newSellingPrice: item.newSellingPrice,
        // oldSellingPrice will not change
        // oldMargin calculated by backend
        // newMargin calculated by backend
        // totalCost calculated by backend
        description: item.description.trim(),
        handWritten: item.handWritten.trim(),
      })),
    };
    debouncedUpdateAll({
      gid: location.pathname.split('/').slice(-1)[0],
      payload,
    });
    // set editing as false
    setIsEditing(false);
  };

  const handleCancel = () => {
    if (isEditing) {
      // set the editing field values to empty object
      setTableFieldValue({});
      // set the editing state to false
      setIsEditing(false);
      // fetch all data
      if (/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
        getData(location.pathname.split('/').slice(-1)[0]);
      }
    }
  };

  const handleShowHistory = (lineItemBarcode, unitCost, itemName) => {
    if (!/^\/lynxconnect\/invoices\/exist\/[^/]+$/.test(location.pathname)) {
      message.error('URL is Malformed.');
      return;
    }
    // fetch api to get the history for the line item
    debouncedFetchInvoiceLineItemsHistory({
      invoiceGid: location.pathname.split('/').slice(-1)[0],
      barcode: lineItemBarcode,
      unitCost,
      itemName,
    });
    // set the modal to display history
    setShowLineItemHistory(true);
  };

  const handlePriceHistoryModalCancel = () => {
    // hide the modal
    setShowLineItemHistory(false);
  };

  const getRowColor = (record) => {
    if (record.newMargin !== record.oldMargin) {
      return {
        style: {
          backgroundColor: LYNX_CONNECT.ROW_HIGHLIGHT,
        },
      };
    }
    return {
      style: {
        backgroundColor: LYNX_CONNECT.ROW_NEUTRAL,
      },
    };
  };

  const getTextColor = (value, compareValue, invert = false) => {
    if (value > compareValue) {
      return invert ? LYNX_CONNECT.TEXT_COLOR.DECREASE : LYNX_CONNECT.TEXT_COLOR.INCREASE;
    }
    if (value < compareValue) {
      return invert ? LYNX_CONNECT.TEXT_COLOR.INCREASE : LYNX_CONNECT.TEXT_COLOR.DECREASE;
    }
    return LYNX_CONNECT.TEXT_COLOR.NEUTRAL;
  };

  const columns = [
    {
      title: 'ITEM NAME',
      dataIndex: 'itemName',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['itemName'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'itemName', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'BARCODE',
      dataIndex: 'barcode',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['barcode'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'barcode', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['sku'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'sku', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'VENDOR ITEM CODE',
      dataIndex: 'vendorItemCode',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['vendorItemCode'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'vendorItemCode', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'UNIT QUANTITY',
      dataIndex: 'quantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['quantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'quantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'quantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'UNIT',
      dataIndex: 'unit',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['unit'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'unit', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'CASE COST',
      dataIndex: 'caseCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
          >
            <EditableCostInput
              valueInCents={tableFieldValue[record.gid]?.['caseCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'caseCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
            {/* {
              tableFieldValue[record.gid]?.['caseCost'] > tableFieldValue[record.gid]?.['previousCaseCost']
                ? <img src={RedIncreaseIndicator} alt="case cost increase indicator" />
                : <></>
            }
            {
              tableFieldValue[record.gid]?.['caseCost'] < tableFieldValue[record.gid]?.['previousCaseCost']
                ? <img src={GreenDecreaseIndicator} alt="case cost decrease indicator" />
                : <></>
            } */}
          </div>
        ) : (
          <span
            style={{
              cursor: 'pointer',
              // color: getTextColor(record.caseCost, record.previousCaseCost, true),
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              gap: '8px',
            }}
          >
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
            {/* {record.caseCost > record.previousCaseCost ? <img src={RedIncreaseIndicator} alt="case cost increase indicator" /> : <></>}
            {record.caseCost < record.previousCaseCost ? <img src={GreenDecreaseIndicator} alt="case cost decrease indicator" /> : <></>} */}
          </span>
        )
      ),
    },
    {
      title: 'CASE QUANTITY',
      dataIndex: 'caseQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['caseQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'caseQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'caseQuantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'ITEM QUANTITY PER CASE',
      dataIndex: 'caseItemQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['caseItemQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'caseItemQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'caseItemQuantity', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'TOTAL ITEM QUANTITY',
      dataIndex: 'totalCaseItemQuantity',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['totalCaseItemQuantity'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'totalCaseItemQuantity', e.target.value)}
            onBlur={(e) => commitChange(record.gid, 'totalCaseItemQuantity', e.target.value)}
            disabled
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'ITEM COST',
      dataIndex: 'unitCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              readOnly="true"
              valueInCents={tableFieldValue[record.gid]?.['unitCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'unitCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'NEW SELLING PRICE',
      dataIndex: 'newSellingPrice',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            <EditableCostInput
              valueInCents={tableFieldValue[record.gid]?.['newSellingPrice']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'newSellingPrice', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
              readOnly={userRole.name === ROLES.WAREHOUSE_ASSOCIATE ? 'true' : 'false'}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'OLD SELLING PRICE',
      dataIndex: 'oldSellingPrice',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              readOnly="true"
              valueInCents={tableFieldValue[record.gid]?.['oldSellingPrice']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'oldSellingPrice', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'OLD MARGIN',
      dataIndex: 'oldMargin',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <section>
            <Input
              readOnly
              value={tableFieldValue[record.gid]?.['oldMargin'] ?? ''}
              onChange={(e) => handleTableFieldEdit(record.gid, 'oldMargin', e.target.value)}
              suffix="%"
              disabled
            />
            {/* <span>%</span> */}
          </section>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}%
          </span>
        )
      ),
    },
    {
      title: 'NEW MARGIN',
      dataIndex: 'newMargin',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <section
            style={{
              display: 'flex',
              flexDirection: 'row',
              flewRow: 'nowrap',
              gap: '8px',
            }}
          >
            <Input
              readOnly
              value={tableFieldValue[record.gid]?.['newMargin'] ?? ''}
              onChange={(e) => handleTableFieldEdit(record.gid, 'newMargin', e.target.value)}
              suffix="%"
              disabled
            />
            {/* <span>%</span> */}
            {
              tableFieldValue[record.gid]?.['newMargin'] > tableFieldValue[record.gid]?.['oldMargin']
                ? <img src={GreenIncreaseIndicator} alt="new margin increase indicator" />
                : <></>
            }
            {
              tableFieldValue[record.gid]?.['newMargin'] < tableFieldValue[record.gid]?.['oldMargin']
                ? <img src={RedDecreaseIndicator} alt="new margin decrease indicator" />
                : <></>
            }
          </section>
        ) : (
          <span
            style={{
              cursor: 'pointer',
              color: getTextColor(record.newMargin, record.oldMargin),
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              gap: '8px',
            }}
          >
            {text || <>&#8211;</>}%
            {record.newMargin > record.oldMargin ? <img src={GreenIncreaseIndicator} alt="new margin increase indicator" /> : <></>}
            {record.newMargin < record.oldMargin ? <img src={RedDecreaseIndicator} alt="new margin decrease indicator" /> : <></>}
          </span>
        )
      ),
    },
    {
      title: 'TOTAL COST',
      dataIndex: 'totalCost',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <div style={{
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
          >
            {/* <span>{selectedAccount.currency.prefix}</span> */}
            <EditableCostInput
              readOnly="true"
              valueInCents={tableFieldValue[record.gid]?.['totalCost']}
              onChange={(newCents) => handleTableFieldEdit(record.gid, 'totalCost', newCents)}
              currencyPrefix={selectedAccount.currency.prefix}
            />
          </div>
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {currencyformatter(Number(text) / 100, selectedAccount.currency.name) || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'DESCRIPTION',
      dataIndex: 'description',
      width: '180px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['description'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'description', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'HAND WRITTEN',
      dataIndex: 'handWritten',
      width: '180px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        isEditing ? (
          <Input
            value={tableFieldValue[record.gid]?.['handWritten'] ?? ''}
            onChange={(e) => handleTableFieldEdit(record.gid, 'handWritten', e.target.value)}
          />
        ) : (
          <span style={{ cursor: 'pointer' }}>
            {text || <>&#8211;</>}
          </span>
        )
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '150px',
      align: 'left',
      // sorter: true,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text, record) => (
        <span>
          {
            isEditing ? (
              <Button
                onClick={() => handleEditModeRowSync(record.gid)}
              >
                <Icon type="sync" />
              </Button>
            ) : (
              <Button
                // onClick={() => handleRowSync(record.gid)}
                disabled
              >
                <Icon type="sync" />
              </Button>
            )
          }
          <Button
            onClick={() => handleShowHistory(record.barcode, record.unitCost, record.itemName)}
          >
            <Icon type="history" />
          </Button>
        </span>
      ),
    },
  ];

  const lineItemHistoryColumns = [
    {
      title: 'Date',
      dataIndex: 'date',
      width: '14%',
      align: 'left',
      render: (text) => {
        let tzDate = text;
        if (selectedAccount && selectedAccount.timezone) {
          tzDate = moment
            .utc(text)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
        }
        return (
          <span style={{ cursor: 'pointer' }}>
            {tzDate || <>&#8211;</>}
          </span>
        );
      },
    },
    {
      title: 'Unit',
      dataIndex: 'unit',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitCost',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {currencyformatter(Number(text) / 100, selectedAccount?.currency?.name) || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'New Price',
      dataIndex: 'newPrice',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {currencyformatter(Number(text) / 100, selectedAccount?.currency?.name) || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Old Price',
      dataIndex: 'oldPrice',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {currencyformatter(Number(text) / 100, selectedAccount?.currency?.name) || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'location',
      width: '14%',
      align: 'left',
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
  ];

  if (!Array.isArray(lynxTenantDetails)
    || lynxTenantDetails.length === 0
    || (lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS
      && lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.WAITING_FOR_APPROVAL
    )
  ) {
    return <></>;
  }

  return (
    <Card>
      <RBAC permit={
        [ROLES.ADMINISTRATOR,
          ROLES.OWNER,
          ROLES.DEVELOPER,
          ROLES.OPERATIONS,
          // ROLES.ANALYST,
          ROLES.SUPPORT,
          ROLES.INTERNALSUPPORT,
          ROLES.POS,
          ROLES.SUPERUSER,
          ROLES.ONBOARDING,
          ROLES.OFFICEMANAGER,
          ROLES.OFFICESUPPORT,
          ROLES.WAREHOUSE_ASSOCIATE,
          ROLES.PRICING_ANALYST,
        ]
            }
      >
        <Spin
          spinning={lynxConnectLoading}
          tip="Please wait..."
          size="large"
          delay={300} // delay in ms to avoid flicker
        >
          <Row
            type="flex"
            justify="end"
            className="mt-2"
          >
            <Col>
              {
                isEditing ? (
                  <SpButton
                    type="primary"
                    shape="round"
                    className="mr-3 btn btn-primary"
                    ghost
                    onClick={handleSave}
                  >
                    Save
                  </SpButton>
                ) : (
                  <SpButton
                    type="primary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={handleEdit}
                    disabled={lynxConnectInvoiceDetail?.status !== LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS}
                  >
                    Edit
                  </SpButton>
                )
              }
            </Col>
            { !isEditing && (
              <Col className="mr-3">
                <RBAC
                  permit={[
                    ROLES.OWNER,
                    ROLES.SUPERUSER,
                    ROLES.INTERNALSUPPORT,
                    ROLES.ONBOARDING,
                    ROLES.WAREHOUSE_ASSOCIATE,
                    ROLES.PRICING_ANALYST,
                  ]}
                >
                  {
                    lynxConnectInvoiceDetail?.status === LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS && (
                      <Button
                        type="primary"
                        shape="round"
                        onClick={handleRequestButton}
                      >
                        Request Approval
                      </Button>
                    )
                  }
                </RBAC>
                <RBAC
                  permit={[
                    ROLES.OWNER,
                    ROLES.SUPERUSER,
                    ROLES.INTERNALSUPPORT,
                    ROLES.ONBOARDING,
                    ROLES.PRICING_ANALYST,
                  ]}
                >
                  {
                    lynxConnectInvoiceDetail?.status === LYNX_CONNECT.INVOICE_STATUS.WAITING_FOR_APPROVAL && (// change
                      <Button
                        type="primary"
                        shape="round"
                        onClick={handlePosUpdate}
                      >
                        Approve
                      </Button>
                    )
                  }
                </RBAC>
              </Col>
            )}
            {
              isEditing && (
                <Col>
                  <SpButton
                    type="dangerSecondary"
                    shape="round"
                    className="mr-3"
                    ghost
                    onClick={handleCancel}
                  >
                    Cancel
                  </SpButton>
                </Col>
              )
            }
            { !isEditing && (
              <Col style={{ display: 'flex', justifyContent: 'center', marginRight: '20px' }}>
                <CSVLink
                  data={fileExportData}
                  headers={fileExportHeaders}
                  filename={csvFileName}
                  className="mt-1"
                  onClick={handleCsvFileDownload}
                >
                  <img src={exportIcon} alt="Export as CSV" />
                </CSVLink>
              </Col>
            )}
          </Row>
          <Spin
            spinning={lynxConnectLoading
              ? false
              : lynxConnectSubLoading.invoiceDetail}
            tip="Please wait..."
            size="large"
            delay={300} // delay in ms to avoid flicker
          >
            <Row
              gutter={16}
              className="mt-3 mr-3 ml-3"
            >
              <Col span={24}>
                <InvoiceDetail
                  selectedAccount={selectedAccount}
                  invoiceDetail={{
                    vendorName: lynxConnectInvoiceDetail?.vendorName ?? '',
                    invoiceNumber: lynxConnectInvoiceDetail?.invoiceNumber ?? '',
                    totalAmount: lynxConnectInvoiceDetail?.totalAmount ?? '',
                    billedTo: lynxConnectInvoiceDetail?.billedTo ?? '',
                    invoiceDate: lynxConnectInvoiceDetail?.invoiceDate ?? '',
                    subTotalAmount: lynxConnectInvoiceDetail?.subTotalAmount ?? '',
                  }}
                />
              </Col>
            </Row>
          </Spin>
          <Row>
            <ViewInvoice
              pdfData={lynxConnectInvoicePdf ?? new ArrayBuffer('')}
              pdfName={lynxConnectInvoiceDetail?.fileName ?? ''}
              showPdfCard={showPdfCard}
              setShowPdfCard={setShowPdfCard}
              loading={lynxConnectSubLoading.pdfData}
            />
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <SmallHeaderTable>
                <Table
                  columns={columns}
                  rowKey={(record) => record.gid}
                  dataSource={lynxConnectExistItems}
                  pagination={false}
                  scroll={{ x: 400, y: 500 }}
                  // size="small"
                  onRow={getRowColor}
                  style={{
                    marginTop: '10px',
                    marginBottom: '10px',
                    marginLeft: '0px',
                    marginRight: '0px',
                  }}
                />
              </SmallHeaderTable>
            </Col>
          </Row>
          <Row
            type="flex"
            align="middle"
            style={{
              backgroundColor: '#f5f5f5', // light gray
              padding: '10px 16px',
              borderRadius: '4px',
              marginBottom: '16px',
            }}
          >
            <Col>
              <h6 style={{ fontWeight: 'bold', margin: 0, marginRight: '20px' }}>
                Total Items Listed: {lynxConnectExistItemsTotalElements}
              </h6>
            </Col>
          </Row>
          <Row>
            <Modal
              title="LynxConnect - Price History"
              width="65vw"
              onCancel={handlePriceHistoryModalCancel}
              footer={[
                <Button key="cancel" onClick={() => setShowLineItemHistory(false)}>
                  cancel
                </Button>,
              ]}
              visible={showLineItemHistory}
            >
              <Row>
                <div style={{
                  background: '#fff',
                  padding: '16px',
                  fontSize: '15px',
                }}
                >
                  {/* First Row: Item and Barcode */}
                  <Row gutter={16}>
                    <Col span={8}>
                      <p style={{ margin: 0 }}>
                        Item:&nbsp;<span style={{ fontWeight: 'bold' }}>{lynxConnectExistItemHistory.itemName}</span>
                      </p>
                    </Col>
                    <Col span={12}>
                      <p style={{ margin: 0 }}>
                        Barcode:&nbsp;<span style={{ fontWeight: 'bold' }}>{lynxConnectExistItemHistory.barcode}</span>
                      </p>
                    </Col>
                  </Row>

                  {/* Second Row: Unit Price */}
                  <Row style={{ marginTop: 8 }}>
                    <Col span={8}>
                      <p style={{ margin: 0 }}>
                        Unit Price:&nbsp;
                        <span style={{ fontWeight: 'bold' }}>
                          {currencyformatter(Number(lynxConnectExistItemHistory.unitCost) / 100, selectedAccount?.currency?.name)}
                        </span>
                      </p>
                    </Col>
                  </Row>
                </div>

                <Row>
                  <SmallHeaderTable>
                    <Table
                      columns={lineItemHistoryColumns}
                      rowKey={(record) => record.id}
                      dataSource={lynxConnectExistItemHistory.history}
                      pagination={false}
                      scroll={{ x: 400, y: 500 }}
                      // size="small"
                      style={{
                        margin: '10px',
                        background: 'transparent',
                        border: 'none',
                        fontSize: '12px',
                      }}
                    />
                  </SmallHeaderTable>
                </Row>
              </Row>
            </Modal>
          </Row>
        </Spin>
      </RBAC>
    </Card>
  );
};

const mapStateToProps = state => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  test: state.account.test,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  lynxConnectExistItems: state.lynxConnect.exist.content,
  lynxConnectExistItemsTotalElements: state.lynxConnect.exist.totalElements,
  lynxConnectExistItemHistory: state.lynxConnect.exist.history,
  lynxConnectExistEditRowSyncStatus: state.lynxConnect.exist.editRowSyncStatus,
  lynxConnectExistSingleLineItem: state.lynxConnect.exist.singleLineItem,
  lynxConnectInvoiceDetail: state.lynxConnect.invoices.invoiceDetail,
  lynxConnectInvoicePdf: state.lynxConnect.pdf,
  lynxConnectLoading: state.lynxConnect.loading,
  lynxConnectSubLoading: state.lynxConnect.subLoading,
  userRole: state.user.role,
  lynxConnectExistUpdatePosStatus: state.lynxConnect.exist.posStatus,
});

const mapDispatchToProps = dispatch => ({
  fetchExist: param => dispatch(lynxConnectActions.fetchExist({
    payload: param,
  })),
  fetchExistHistory: param => dispatch(lynxConnectActions.fetchExistHistory({
    payload: param,
  })),
  existUpdateAll: param => dispatch(lynxConnectActions.existUpdateAll({
    payload: param,
  })),
  existEditRowSync: param => dispatch(lynxConnectActions.existEditRowSync({
    payload: param,
  })),
  existSetSingleLineItemValue: param => dispatch(lynxConnectActions.existSingleLineItemValue({
    payload: param,
  })),
  existRowSync: param => dispatch(lynxConnectActions.existRowSync({
    payload: param,
  })),
  existEditRowSyncStatus: param => dispatch(lynxConnectActions.existEditRowSyncStatus({
    payload: param,
  })),
  existSetTableData: param => dispatch(lynxConnectActions.existSetTableData({
    payload: param,
  })),
  resetExistLineItems: param => dispatch(lynxConnectActions.resetExistLineItems({
    payload: param,
  })),
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
  setInvoicePdf: param => dispatch(lynxConnectActions.setInvoicePdf({
    payload: param,
  })),
  setLoading: param => dispatch(lynxConnectActions.setLoading({
    payload: param,
  })),
  fetchInvoiceDetail: param => dispatch(lynxConnectActions.fetchInvoiceDetail({
    payload: param,
  })),
  fetchInvoicePdf: param => dispatch(lynxConnectActions.fetchInvoicePdf({
    payload: param,
  })),
  setAuditEvent: param => dispatch(lynxConnectActions.setAuditEvent({
    payload: param,
  })),
  requestApproval: param => dispatch(lynxConnectActions.requestApproval({
    payload: param,
  })),
  existUpdatePos: param => dispatch(lynxConnectActions.existUpdatePos({
    payload: param,
  })),
  setPosStatus: param => dispatch(lynxConnectActions.setPosStatus({
    payload: param,
  })),
  setExistLineItemTotalElements: param => dispatch(lynxConnectActions.setExistLineItemTotalElements({
    payload: param,
  }))
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LynxConnectInvoiceLineItemsExist));
